/**
 * Latori: the header cart icon opens the cart PAGE, while adding something to
 * the cart still opens the drawer.
 *
 * Symmetry couples both to `settings.cart_type`, so the combination is not
 * configurable: the store needs `drawer` (that setting is also what renders the
 * drawer element at all — see the guard at the top of sections/cart-drawer.liquid
 * — and `.js-cart-drawer` is what `after_add_to_cart: drawer` opens), but with
 * it main.js binds a delegated click handler on the header that
 * `preventDefault()`s `.cart-link` and opens the drawer instead.
 *
 * Catching the click in the capture phase on `document` — before it reaches that
 * delegate, which listens in the bubble phase on the header element — stops the
 * drawer from opening and lets the anchor navigate to `routes.cart_url` on its
 * own. Done here rather than in main.js so the vendor file stays untouched, and
 * it keeps working across the header's section re-renders (which re-bind the
 * vendor handler on every cart change).
 */
document.addEventListener(
  'click',
  (evt) => {
    const target = evt.target;
    if (!target || typeof target.closest !== 'function') return;
    if (!target.closest('.cart-link')) return;

    // Only the vendor's drawer delegate is on the path to be cancelled; the
    // link's own default navigation is deliberately left intact.
    evt.stopPropagation();
  },
  true,
);
